import axios from 'axios';

// Base api instance with default configuration
export const api = axios.create({
  baseURL: '/api/v1/',
});
